import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Slider from "react-slick";
import { history } from '../../../../helpers';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (<div className={className}
        style={{ ...style, display: "block", }}
        onClick={onClick}>
        <div><img src="/images/svg/arrow-right.svg" /></div>
    </div>);
}
  
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (<div className={className}
        style={{ ...style, display: "block", }}
        onClick={onClick}>
        <div><img src="/images/svg/arrow-left.svg" /></div>
    </div>);
}

class BottomSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
    }
    
    componentDidMount() {
    }

    tutorSearch = (e, name) => {
        e.preventDefault();
        const formField = {
            subject: name,
        };
        history.push({
            pathname: `/search-tutors`,
            state: { formField }
        });
    }

    render() {
        const { cateArray } = this.props;

        const settings = {
            className: "bottom-slider",
            centerMode: true,
            centerPadding: "60px",
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                  }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        };

        return (<section className="slider mb-5">
            <Slider {...settings}>
                {cateArray && cateArray.map(item => 
                <div className="item" key={`cat-${item.id}`}>
                    <div className="image">
                      <img className="img-fluid homeSlider" src={(item.media_id === null) ? '/images/defaultHomeBottonSlider.png' : item.media.path} alt="Banner" />
                    </div>
                    <div className="caption">
                        <h4 className="text-center" onClick={(e) => this.tutorSearch(e, item.name)}>{item.name}</h4>
                    </div>
                </div>
                )}                
            </Slider>
        </section>);
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    authenticationSelector,
    (authentication) => ({
        authentication
    })
);

export default connect(mapStateToProps)(BottomSlider);
